import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import store from "redux/store";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (401 === error?.response?.status) {
      window.location.href = "/unauthorized";
    }
    return Promise.reject(error);
  }
);

const processHeader = (shouldVerifyCookie = true) => {
  const tokenType = store.getState().auth?.authUser?.token_type;
  const token = store.getState().auth?.authUser?.access_token || "";
  const isLoginOverride = store.getState().auth?.authUser?.isLoginOverride || false;

  if (isLoginOverride) {
    shouldVerifyCookie = false;
  }

  if (shouldVerifyCookie) {
    try {
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";").map((m) => m.trim());
      //console.log(`here is the cookie\n`, decodedCookie);
      let cookieToken = ca.find((f) => f.indexOf("MStation=id=") !== -1).substring(12);
      if (!cookieToken) {
        throw `cookie not found`;
      }
    } catch (_e) {
      //console.log(`redirected from appService\n`, _e);
      window.location.href = "/unauthorized";
      return;
    }
  }

  const headers: AxiosRequestHeaders = {
    Authorization: `${tokenType} ${token}`,
    "Content-Type": "application/json",
  };

  //console.log("Headers: ", headers);
  return { headers };
};

const get = (url: string, config?: AxiosRequestConfig) => {
  let blobConfiguration = {};
  if (url.indexOf("&pdf=1") >= 0) {
    blobConfiguration = { responseType: "blob" };
  }

  //console.log(`axios Get: url is: `, url);
  return axios.get(url, {
    ...processHeader(),
    ...config,
    ...blobConfiguration,
  });
};

const post = (url: string, params: any, config?: AxiosRequestConfig) => {
  //console.log(`axios Post: url is: `, url);
  //console.log(`axios Post: params is: `, params);
  //console.log(`axios Post: config is: `, config);
  const result = axios.post(url, params, {
    ...processHeader(url.toLowerCase().indexOf("/login/") === -1),
    ...config,
  });
  //console.log(`axios Post: result is: `, result);
  return result;
};

const put = (url: string, params: any, config?: AxiosRequestConfig) => {
  //console.log(`axios Put: url is: `, url);
  //console.log(`axios Put: params is: `, params);
  //console.log(`axios Put: config is: `, config);
  const result = axios.put(url, params, { ...processHeader(), ...config });
  //console.log(`axios Put: result is: `, result);
  return result;
};

const del = (url: string, config?: AxiosRequestConfig) => {
  return axios.delete(url, { ...processHeader(), ...config });
};

export default { del, get, post, put };
